<template>
  <TagSelector
    :multiple="multiple"
    :items="lists"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    };
  },
  created() {
    this.setLists();
  },
  methods: {
    async setLists() {
      const { data } = await this.$api.List.lite();
      this.lists = data;
    },
  },
};
</script>

<style></style>
